// extracted by mini-css-extract-plugin
export var icon = "_qf-0";